import EsignCallbackPage from '@/client-portal/pages/EsignCallbackPage.vue';
import MultiFactorAuthenticationSend from '@/company-portal/pages/MultiFactorAuthenticationSend.vue';
import MultiFactorAuthenticationVerify from '@/company-portal/pages/MultiFactorAuthenticationVerify.vue';
import CsrfField from '@/components/auth/CsrfField.vue';
import DesignSamples from '@/components/design-system/design-samples/DesignSamples.vue';
import DsAddressAutocompleteSearch from '@/components/design-system/form/input/DsAddressAutocomplete/DsAddressAutocompleteSearch.vue';
import ClosinglockHeader from '@/components/Navigation/ClosinglockHeader.vue';
import CompanyNavigation from '@/components/Navigation/top-nav/CompanyNavigation.vue';
import EmployeeNavigation from '@/components/Navigation/top-nav/EmployeeNavigation.vue';
import ShadowButton from '@/components/Navigation/top-nav/ShadowButton.vue';
import ShadowWarning from '@/components/Navigation/top-nav/ShadowWarning.vue';
import AccountActions from '@/components/PageSections/AccountActions.vue';
import AddFileForm from '@/components/Views/Company/AddFile/AddFileForm.vue';
import DocumentUploadSection from '@/components/Views/Company/AddFile/DocumentUploadSection.vue';
import NotificationSection from '@/components/Views/Company/AddFile/NotificationSection.vue';
import CompanyFooter from '@/components/Views/Company/CompanyFooter.vue';
import EarlyDepositForm from '@/components/Views/Company/EarlyDepositForm.vue';
import FileTable from '@/components/Views/Company/File/FileTable.vue';
import AutomatedTaskReminders from '@/components/Views/Company/Settings/AutomatedTaskReminders.vue';
import BootstrapCheckbox from '@/components/Views/Company/Settings/BootstrapCheckbox.vue';
import EvidenceOfInsurance from '@/components/Views/Company/Settings/EvidenceOfInsurance.vue';
import OpenLinkSettingsModal from '@/components/Views/Company/Settings/OpenLinkSettingsModal.vue';
import WatermarkOnWireInstructions from '@/components/Views/Company/Settings/WatermarkOnWireInstructions.vue';
import ViewEarlyDepositTable from '@/components/Views/Company/ViewEarlyDepositTable.vue';
import StateSelector from '@/employee-portal/shared/StateSelector.vue';
import CompanyPortalCommonLayout from '@/layouts/CompanyPortalCommonLayout.vue';

/*
  This list contains components that are used as entry points when initVueSprinkle is used.
  Descendant components are resolved as usual
  When using them in blade templates, declare the component tag using <kebab-case />
*/
export const allComponents = {
    AccountActions,
    AddFileForm,
    AutomatedTaskReminders,
    BootstrapCheckbox,
    ClosinglockHeader,
    CompanyFooter,
    CompanyNavigation,
    CompanyPortalCommonLayout,
    CsrfField,
    DesignSamples,
    DocumentUploadSection,
    DsAddressAutocompleteSearch,
    EarlyDepositForm,
    EmployeeNavigation,
    EsignCallbackPage,
    EvidenceOfInsurance,
    FileTable,
    MultiFactorAuthenticationSend,
    NotificationSection,
    MultiFactorAuthenticationVerify,
    OpenLinkSettingsModal,
    ShadowButton,
    ShadowWarning,
    StateSelector,
    ViewEarlyDepositTable,
    WatermarkOnWireInstructions,
};
